
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 14.68a.5.5 0 01-.2-.04L.3 9.81a.5.5 0 010-.92l11.5-4.84a.5.5 0 01.4 0L23.7 8.9a.5.5 0 010 .92l-11.5 4.83a.5.5 0 01-.2.04zM1.79 9.35L12 13.64l10.21-4.3L12 5.06z"}}),_c('path',{attrs:{"d":"M1.62 16.07a.5.5 0 01-.5-.5v-5.4a.5.5 0 011 0v5.4a.5.5 0 01-.5.5zm4.29 1.83a.5.5 0 01-.5-.5v-5.5a.5.5 0 011 0v5.5a.5.5 0 01-.5.5zm12.01.13a.5.5 0 01-.5-.5v-5.62a.5.5 0 011 0v5.62a.5.5 0 01-.5.5z"}}),_c('path',{attrs:{"d":"M12.36 19.99c-2.79 0-6.91-.84-6.91-2.65a.5.5 0 011 0c0 .56 2.5 1.65 5.9 1.65 3.1 0 5.08-.98 5.08-1.65a.5.5 0 011 0c0 1.72-3.13 2.65-6.07 2.65z"}})])
          )
        }
      }
    